import orderConfig from 'emun.order/order.config';
import basicController from "servicestack/basic.controller.properties";
import AutoQuery from "servicestack/auto-query/auto-query";
import "emun.auth/users/user-picker.htm";
//import customerConfig from "emun.customer/customer.config";
import UserParser from "emun.auth/users/user-parser";
//import ApplyTagsPrompt from "emun.customer/picker/apply-retailer-tags-prompt";

//export const filters = customerConfig.filters;

export const views = {
	list: "table",
	//  cards: "th-large"
};

export default class UserPickerController {
	constructor(options) {
		const $ctrl = this;
		basicController($ctrl);
		$ctrl.selected = {};
		Object.assign($ctrl, options);
		$ctrl.setUserIds();
		$ctrl.query = new AutoQuery($ctrl.getAutoQueryOptions());
		$ctrl.bus = $ctrl.query.bus;
		//$ctrl.viewSelectionsChanged(); //load()
	}

	templateUrl = () => `user-picker-table.htm`;

	selectAll() {
		const $ctrl = this;
		$ctrl.query.results.forEach(p => ($ctrl.selected[p.userName] = true));
		this.setUserIds();
	}
	clearAll() {
		this.selected = {};
		this.setUserIds();
	}
	canClear() {
		return Object.keys(this.selected).length;
	}

	isSelected(user) {
		return !!this.selected[user.salesRepId];
	}

	setUserIds() {
		this.userNames = Object.keys(this.selected || {});
	}

	selectionsLabel() {
		const { userNames: keys = [] } = this;
		if (keys.length > 4)
			return `Selected: ${keys.slice(0, 4).join(", ")} and ${keys.length -
				4} more...`;
		if (keys.length > 0) return `Selected: ${keys.slice(0, 4).join(", ")}`;
		return "No selections";
	}

	hasSelections = () => Object.keys(this.selected).length > 0;

	viewSelectionsChanged() {
		const $ctrl = this;
		const idIn = $ctrl.viewSelections
			? Object.keys($ctrl.selected || {}).join(",")
			: null;
		$ctrl.query.clearRefinements(false);
		$ctrl.query.filter("IdIn", idIn);
	}

	toggle(user) {
		const $ctrl = this;
		console.log("toggle", user.salesRepId, $ctrl.selected, user);

		if ($ctrl.single) {
			$ctrl.$close(user);
		} else if (user.salesRepId in $ctrl.selected) {
			delete $ctrl.selected[user.salesRepId];
			$ctrl.onUserUnSelected &&
				$ctrl.onUserUnSelected({ $user: user, ...$ctrl });
		} else {
			$ctrl.selected[user.salesRepId] = true;
			$ctrl.onUserSelected &&
				$ctrl.onUserSelected({ $user: user, ...$ctrl });
		}
		this.setUserIds();
	}
	select(user) {
		const $ctrl = this;
		$ctrl.$close([user]);
	}

	$onDestroy() {
		this.query.dispose();
	}

	parseUsers() {
		const $ctrl = this;
		UserParser({}).then(userNames => {
			$ctrl.selected = {};
			userNames.forEach(userName => {
				$ctrl.toggle({ userName: userName });
			});
			$ctrl.viewSelections = true;
			$ctrl.viewSelectionsChanged();
		});
	}

	getAutoQueryOptions() {
		const $ctrl = this;
		return {
			url: "QueryUsers.json?RolesIn=Rep,Sales Manager,Manager",
			pageSize: $ctrl.$pageConfig.is("gt-sm") ? 12 : 6,
			views,
			criteria: $ctrl.criteria,
			view: "table",
//			filters,
			sortOptions: {
				"DisplayName": "Name: A to Z",
				"-DisplayName": "Name: Z to A"
			},
			hideLeftNav: true, // $ctrl.$pageConfig.is('gt-sm'),
			orderBy: "DisplayName,Id",
			autoLoad: true,
			append: false
		};
	}
}


